import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  IconPicklist,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSelection/components/IconPicklist/IconPicklist';
import { FDBigPicklistInput } from '@facet-wealth/design';

export const SelectOutcomeStepMetaOverride = buildFacetDesignOverride()
  .typeOverride('picklist', {
    _component: () => IconPicklist,
    _customProps: {
      condensed: true,
    },
  }, overrideReadOnly);

export const GoalDetailStepMetaOverride = buildFacetDesignOverride()
  .nameOverride('primaryActionLabel', {
    hidden: true,
  }, overrideReadOnly)
  .nameOverride('debtPayOffPreference', {
    _component: () => FDBigPicklistInput,
    _customProps: {
      helperText: '',
    },
  }, overrideReadOnly);
